import { useState } from 'react';
import { inMemoryKVStore } from '../../../../../infra/persistence';
import { TYPE_FILTER_KEY } from '../../types';
import { isPromotionCampaign, isUpdateCampaign } from '../../../campaign-utils';
export var useTypeFilter = function () {
    var _a = useState(inMemoryKVStore.getItem(TYPE_FILTER_KEY) || 'all'), typeFilter = _a[0], setLocalTypeFilter = _a[1];
    var setTypeFilter = function (newTypeFilter) {
        setLocalTypeFilter(newTypeFilter);
        inMemoryKVStore.setItem(TYPE_FILTER_KEY, newTypeFilter);
    };
    var filterByType = function (row) {
        var rowCampaign = row.original;
        switch (typeFilter) {
            case 'all':
                return true;
            case 'update':
                return isUpdateCampaign(rowCampaign);
            case 'promotion':
                return isPromotionCampaign(rowCampaign);
            default:
                return false;
        }
    };
    return {
        typeFilter: typeFilter,
        setTypeFilter: setTypeFilter,
        filterByType: filterByType,
    };
};
